document.addEventListener("DOMContentLoaded", function () {
  const triggerButtons = document.querySelectorAll(".js-open-popup");
  const popupWrapper  = document.querySelector(".js-upsell-popup");
  const closeButton   = document.querySelector(".js-close-popup");

  let timerInterval = null;

  const disableScroll = () => { document.body.style.overflow = "hidden"; };
  const enableScroll  = () => { document.body.style.overflow = ""; };

  function startPopupTimer() {
    const timerEl = popupWrapper?.querySelector(".js-timer-popup");
    if (!timerEl) return;

    const initialSeconds = parseInt(timerEl.dataset.seconds, 10) || 0;
    let totalSeconds = initialSeconds;

    function render() {
      const mins = Math.floor(totalSeconds / 60);
      const secs = totalSeconds % 60;
      timerEl.textContent = `${mins}:${secs.toString().padStart(2, "0")}`;
    }

    const declineLink = popupWrapper.querySelector(".js-decline-button");
    console.log('declineLink', declineLink);

    function tick() {
      if (totalSeconds <= 0) {
        clearInterval(timerInterval);
        // On expiry, follow the decline link
        const declineLink = popupWrapper.querySelector(".js-decline-button");
        if (declineLink && declineLink.href) {
          window.location.href = declineLink.href;
        }
        return;
      }
      totalSeconds -= 1;
      render();
    }

    clearInterval(timerInterval);
    render();                      
    timerInterval = setInterval(tick, 1000);
  }

  function stopPopupTimer() {
    clearInterval(timerInterval);
    timerInterval = null;
  }

  function openPopup() {
    disableScroll();
    popupWrapper.classList.add("active");
    startPopupTimer();
  }

  function closePopup() {
    enableScroll();
    popupWrapper.classList.remove("active");
    stopPopupTimer();
  }

  triggerButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openPopup();
    });
  });

  if (closeButton) {
    closeButton.addEventListener("click", function (e) {
      e.preventDefault();
      closePopup();
      console.log('declineLink', declineLink);
    });
  }
});
